import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { TALENT_ID } from '../../data/define';
import { intelligencesOrdering } from '../../utility/intelligencesOrdering';
import { useTranslation } from '../../hook/useTranslation';

const order = [
  TALENT_ID.RELATIONSHIP,
  TALENT_ID.LANGUAGE,
  TALENT_ID.NATURE,
  TALENT_ID.PHYSICAL,
  TALENT_ID.REFLECTION,
  TALENT_ID.MATH,
  TALENT_ID.SPACE,
  TALENT_ID.MUSIC,
];

function StrengthWeaknessRadar({ result = [] }) {
  const { t } = useTranslation();
  const [newResult, setNewResult] = useState([]);
  const [series, setSeries] = useState([
    {
      data: [5, 5, 5, 5, 5, 5, 5, 5], // 기본값으로 5으로 설정
    },
  ]);

  // result에 값이 없는 항목은 5점으로 넣기
  useEffect(() => {
    if (result && result.length > 0) {
      const fullIds = [1, 2, 3, 4, 5, 6, 7, 8];
      const existingIds = new Set(result.map((item) => item.id));
      const missing = fullIds.filter((id) => !existingIds.has(id)).map((id) => ({ id, score: 5 }));
      setNewResult([...result, ...missing]);
    } else {
      setNewResult([]);
    }
  }, [result]);

  // series 업데이트
  useEffect(() => {
    if (newResult && newResult.length > 0) {
      const reorderedResult = intelligencesOrdering(order, newResult);
      setSeries([
        {
          data: reorderedResult.map((item) => item.score || 5),
        },
      ]);
    }
  }, [newResult]);

  const options = {
    chart: {
      height: 350,
      type: 'radar',
      toolbar: {
        show: false,
      },
    },
    yaxis: {
      // stepSize: 20,
      max: 100,
      labels: {
        formatter: () => '', // 빈문자열로 공백처리
      },
      axisTicks: { show: false },
      axisBorder: { show: false },
    },
    xaxis: {
      labels: {
        show: true,
        style: {
          fontSize: '12px',
          fontWeight: 400,
          colors: [
            '#363636',
            '#363636',
            '#363636',
            '#363636',
            '#363636',
            '#363636',
            '#363636',
            '#363636',
          ],
        },
      },
      categories: [
        t('talent.relationship'),
        t('talent.language'),
        t('talent.nature'),
        t('talent.physical'),
        t('talent.reflection'),
        t('talent.math'),
        t('talent.space'),
        t('talent.music'),
      ],
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    plotOptions: {
      radar: {
        polygons: {
          strokeColors: '#F3F3F3',
          strokeWidth: 2,
          fill: {
            colors: ['transparent'],
          },
        },
      },
    },
    stroke: {
      width: 4, // 데이터 라인 두께
      colors: ['#76DFE1'], // 데이터 라인 색
    },
    fill: {
      colors: ['#76DFE1'],
      opacity: 0.4, // 데이터 영역 채우기 투명도
    },
  };

  return (
    <div className="w-full pt-[20px] relative">
      <div className="flex items-center justify-start gap-2 mb-[-10px]">
        <div className="text-[#1C1C1C] font-[700] text-[20px] text-left">
          {t('report.radar.title')}
        </div>
      </div>
      <ReactApexChart options={options as any} series={series} type="radar" height={350} />
    </div>
  );
}

export default StrengthWeaknessRadar;
